import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink, {TransitionState} from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import prevImage from "../images/Hero_01_Welcome.jpg"
import chevronDown from "../images/angle-down.svg"
import nextImage from "../images/Hero_Officers.jpg"
import arrowLeft from "../images/yellow-arrow.svg"
import prevRings from "../images/RINGS_GREEEN_YELLOW.svg"
import nextRings from "../images/RINGS_BLUE_YELLOW.svg"
import useWindowSize from "../hooks/useWindowDimensions"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"
import { Link } from "gatsby"

import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const BoardCeoLetters = (props) => {
    const circles = useRef([]);
    const firstRow = useRef();
    const ceoLetter = useRef();
    const navList = useRef();
    const doubleProfile = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);
    const size = useWindowSize();

    useEffect(() => {
        const mql = window.matchMedia('(min-width: 1024px)');
        // console.log(mql.matches, 'f');
        setDesktopViewState(mql.matches);
    }, [size, desktopViewState]);

    useLayoutEffect(() => {
        const mql = window.matchMedia('(min-width: 1024px)');
		const mqhl = window.matchMedia('(min-height: 800px)');
        // console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(firstRow.current, { y: 200, ease: "power2"});
        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
        // console.log(mql.matches, 'state');
        let q = gsap.utils.selector(doubleProfile.current);
        let tl = gsap.timeline({paused: true})
        .to(q(".profile-2"), {y: 600, opacity: 0, display: 'none', duration: 2, ease: 'power3'})
        .to(q(".profile-1"), {scale: '1.4', top: 60, left: 60, duration: 1.5, ease: 'elastic'}, "-=1.75")
        // .to(q(".profile-1 .rings"), {rotate: 360, duration: 1.5}, "-=1.75")
        if(mql.matches && mqhl.matches  ) {
            tl.to(q(".profile-1"), {scale: '1.4', top: 60, left: 60, duration: 1.5, ease: 'elastic'}, "-=1.75")
        }
		if(mql.matches && !mqhl.matches  ) {
            tl.to(q(".profile-1"), {scale: '1.2', top: 10, left: 40, duration: 1.5, ease: 'elastic'}, "-=1.75")
        }
        if(!mql.matches) {
            tl.to(q(".profile-1"), {scale: '1.1', top: 0, left: 0, width: '360px', height: '360px', duration: 1.5, ease: 'elastic'}, "-=1.75")   
        }
        setTimeout(function() {
            tl.play(0);
        }, 250);
            
    }, []);

    function exitAnimation(exit, node, int) {
        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    function handleClick(id) {
        id.current.scrollIntoView({behavior:"smooth"});
    }

    return (
        <Layout>
            <main className="page board-ceo-letters">
                <title>CEO & Board Letters</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 1 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li onClick={() => {handleClick(firstRow)}} data-url="board-letter" className="text--yellow">Board Letter</li>
                                <li onClick={() => {handleClick(ceoLetter)}} data-url="ceo-letter" className="text--yellow">CEO Letter</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile" ref={doubleProfile}>
                                        <div className="profile-1">
                                            <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_02a_BoardLetter.jpg" alt="" />
                                            <img className="rings" src={ringsmy} alt="" /> 
                                        </div>
                                        <div className="profile-2">
                                            <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_02b_CEOLetter_REV.jpg" alt="" />
                                            <img className="rings" src={ringscy} alt="" /> 
                                        </div>
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline">Leading</div>
                                        <h1>TOGETHER</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    
                                                }}
                                                entry={{
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div 
                                    className="circle--blue top"
                                    ref={(element) => circles.current[0] = element}
                                    data-speed=".3"
                                ></div>
                                <div
                                    className="circle--yellow top" 
                                    ref={(element) => circles.current[1] = element}
                                    data-speed="-.7"
                                ></div>
                                <div
                                    className="circle--green top" 
                                    ref={(element) => circles.current[2] = element}
                                    data-speed=".1"
                                ></div>
                            </section>
                        </div>
                        
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                    <div className="col-xs-12">
                        <h2>To Our Members & Stakeholders</h2>
                        <p className="text text--large text--bold">The year 2021 challenged the electricity industry in many ways. Into its second year, the COVID-19 pandemic demanded vigilance, ingenuity and perseverance. Industry resilience was further tested by extreme winter weather that drove PJM energy exports to record levels to aid neighboring systems.</p>
                        <p className="text">The defining purpose to maintain the reliability of the bulk electric system guided the PJM Board of Managers, PJM staff, members and stakeholders to collaborate in new, proactive ways to meet the demands of 2021.</p>
                        <p className="text">In my first year as Board chair of the largest grid operator in the U.S., I was honored to lead a thoughtful and committed Board that was focused on reliability, strengthening risk management, evolving competitive markets, and expediting an inclusive planning process to enhance resilience and reliability required now and in the future. A review of 2021 would not be complete without acknowledging the contributions of Ake Almgren, who served as Board chairman from 2018 until mid-2021. Almgren arrived on PJM’s Board in 2003 and was a guiding force as the RTO doubled in size to achieve huge, continuing benefits of scale.</p>
                    </div>
                </div>
                <div className="row row-wrapper content m-t-40">
                <div className="col-xs-12 col-md-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <div className="bio__item">
                                    <div className="profile profile--small">
                                        <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Takahashi_Mark.jpg" alt="" />
                                        <img className="rings" src={ringsmy} alt="" /> 
                                    </div>
                                    <div className="bio">
                                        <div className="name">MARK TAKAHASHI</div>
                                        <div className="position"><span>Chair | PJM Board of Managers</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <div className="bio__item">
                                    <div className="profile profile--small">
                                        <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/Hero_02b_CEOLetter_REV.jpg" alt="" />
                                        <img className="rings" src={ringsgy} alt="" /> 
                                    </div>
                                    <div className="bio">
                                        <div className="name">MANU ASTHANA</div>
                                        <div className="position">President & CEO<br />PJM Interconnection</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6 mobile-margin-top">
                        <p className="text">Going forward, PJM’s stewardship of its responsibilities continues to be pivotal for stakeholders amid the massive energy transition. To that end, the PJM Board of Managers supports PJM’s strategic plan guided by three foundational pillars: (i) facilitating decarbonization, (ii) planning the grid of the future, and (iii) fostering innovation. These pillars rest on PJM’s already strong performance in, and commitment to, its foundation in reliability, transparent stakeholder engagement, risk management and workforce development. </p>
                        <p className="text">In response to evolving needs, the PJM Board accelerated engagement and action in 2021. The revised Minimum Offer Price Rule accommodates state policy and self-supply business models, addresses attempted exercises of buyer-side market power, and creates a sustainable market design by keeping clearing prices consistent with supply and demand fundamentals. For this progress, the Board commends PJM stakeholders for their commitment to collaboration.</p>
                    </div>
                </div>
                <div className="row row-wrapper">
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Blackwell_Terry.jpg" alt="" />
                                <img className="rings" src={ringsby} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">TERRY BLACKWELL</div>
                                <div className="position"><span>Chair | Human Resources Committee</span><br/><span className="add-top-margin">Member | Board Governance Committee, Reliability & Security Committee</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Conboy_Paula.jpg" alt="" />
                                <img className="rings" src={ringscy} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">Paula Conboy</div>
                                <div className="position">Chair | Regulatory Committee<br/><span className="add-top-margin">Member | Competitive Markets Committee, Governance Committee</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Johnson_Jeanine.jpg" alt="" />
                                <img className="rings" src={ringsbm} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">Jeanine Johnson</div>
                                <div className="position">Member | Finance Committee, Reliability & Security Committee, Risk & Audit Committee</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Loebl_Margo.jpg" alt="" />
                                <img className="rings" src={ringsgy} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">Margaret Loebl</div>
                                <div className="position"><span>Chair | Risk & Audit Committee</span><br/><span className="add-top-margin">Member | Competitive Markets Committee, Regulatory Committee</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper">
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Mills_David.jpg" alt="" />
                                <img className="rings" src={ringsmy} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">David E. Mills</div>
                                <div className="position">Chair | Competitive Markets Committee<br/><span className="add-top-margin">Member | Human Resources Committee, Risk & Audit Committee</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Oskvig_Dean.jpg" alt="" />
                                <img className="rings" src={ringsby} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">O.H. Dean Oskvig</div>
                                <div className="position"><span>Chair | Reliability & Security Committee</span><br/><span className="add-top-margin">Member | Board Governance Committee, Human Resources Committee</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Robinson_Charlie.jpg" alt="" />
                                <img className="rings" src={ringscy} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">Charles F. Robinson</div>
                                <div className="position"><span>Chair | Board Governance Committee</span><br/><span className="add-top-margin">Member | Competitive Markets Committee, Finance Committee</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3">
                        <div className="bio__item">
                            <div className="profile profile--small">
                                <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/BoardWeb_2022_Robinson_Sarah.jpg" alt="" />
                                <img className="rings" src={ringsbm} alt="" /> 
                            </div>
                            <div className="bio">
                                <div className="name">Sarah S. Rogers</div>
                                <div className="position"><span>Member | Human Resources Committee, Reliability & Security Committee, Regulatory Committee</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper content m-t-20">
                    <div className="col-xs-12 m-t-40">
                        <p className="text">The PJM Board ensures that risk management informs all aspects of RTO operations and is pleased to report the implementation of the Enterprise Risk Management strategy and practices across all PJM divisions in 2021.</p>
                        <p className="text">As PJM plans for the reliable grid of the future, the intersection of planning and decarbonization requires significant changes in regional planning activities. PJM takes seriously its role as an independent planner for the nation’s largest grid, providing critical studies in 2021 that examined the expansion of offshore wind as well as the impacts of renewable integration.</p>
                    </div>
                </div>
                <div className="row row-wrapper content m-t-30">
                    <div className="col-xs-12">
                        <p className="text">Finally, assuring reliable operations through unforeseen events remains the core strength of PJM and its generation and transmission network. On behalf of PJM and the Board, I wish to extend appreciation for input and participation from the broad spectrum of PJM members and stakeholders as we fulfilled our joint purpose in 2021 and partnered to meet the demands of the future. The many perspectives shared helped shape our approach, and we are grateful for the accomplishments.
                        </p>
                        <p className="text">Sincerely,</p>
                        <p className="text text--bold">Mark Takahashi<br></br>Chair | PJM Board of Managers</p>
                    </div>
                </div>
                <div className="page-set--in-flow">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile">
                                        <StaticImage loading="lazy" quality="50" placeholder="blurred" objectFit="contain" className="avatar" src="../images/Hero_02b_CEOLetter_REV.jpg" alt="" />
                                        <img className="rings" src={ringscy} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline text--primary">RISING TO THE</div>
                                        <h1 className="text--primary">CHALLENGE</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    
                                                }}
                                                entry={{
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                </div>
                                <div 
                                    className="circle--pink"
                                    ref={(element) => circles.current[3] = element}
                                    data-speed=".1"
                                ></div>
                                <div
                                    className="circle--blue" 
                                    ref={(element) => circles.current[4] = element}
                                    data-speed="-.4"
                                ></div>
                                <div
                                    className="circle--green" 
                                    ref={(element) => circles.current[4] = element}
                                    data-speed="-.4"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div ref={ceoLetter} className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h2>To Our Members, Stakeholders &amp; Employees</h2>
                        <p className="text text--large">In 2021, PJM and its stakeholders continued to be “powered by purpose” and remained focused on our core mission of ensuring reliability for 65 million people in 13 states and Washington, D.C.</p>
                        <p className="text">The reliable delivery of electricity is essential to modern life; this was never clearer than in February 2021, when winter storm Uri brought extreme cold weather and devastating power outages to Texas and the South Central states, with tragic consequences. During this time, PJM’s generation fleet and transmission network exported record amounts of power to neighboring grid operators, highlighting the opportunity for mutual support that customers within the Eastern Interconnection have benefited from for years. I’m proud of our planning, preparation and coordination with member companies to deliver this outcome and am deeply grateful for the work of our industry front-line workers – line crews, control room operators and others that keep the power flowing during extreme conditions.</p>
                        <p className="text">In addition, PJM and the electricity industry stepped up our efforts around cybersecurity initiatives to protect against the increased threat of ransomware. PJM once again participated in GridEx, the largest grid security exercise in North America, to drill a coordinated response to attacks on critical infrastructure.</p>
                        <p className="text">I want to recognize the PJM team and our member and industry partners for these incredibly important contributions and for their unwavering commitment to reliability.</p>
                        <p className="text">In 2021, I am also grateful for the positive momentum achieved by our stakeholders and PJM staff on several important and complex issues. Our stakeholders, staff and the PJM Board of Managers partnered to amend the Minimum Offer Price Rule (MOPR) in our capacity market to help facilitate the energy policy aspirations of our states while maintaining market participation. PJM also worked with diverse stakeholder interests to implement Effective Load Carrying Capability (ELCC), a tremendous step forward in valuing the capacity of variable or limited generation resources, such as wind, solar and storage.</p>
                        <p className="text">We embarked with stakeholders on a comprehensive look at future resource adequacy enhancements via a new senior task force, informed by studies published in 2021 focused on how we can reliably and affordably integrate the significant amount of renewable generation that is poised to come online. </p>
                        
                    </div>
                </div>
                <div className="quote-wrap bg-blue sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <div className="p-t-40 p-b-40">
                                <div className="row row-wrapper content max--1024">
                                    <div className="col-xs-12 text--center">
                                        <p className="text text--yellow text--large quote-text">&#8220;I want to recognize the PJM team and our member and industry partners for these incredibly important contributions and for their unwavering commitment to reliability.&#8221;</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <p className="text">Our progress also included groundbreaking work on offshore wind, including a first-of-its-kind agreement with New Jersey to evaluate offshore wind transmission proposals, as well as a regional offshore wind study that analyzed opportunities where states could coordinate in pursuit of their renewable energy policy goals. We made substantial progress toward our February 2022 filing under FERC Order 2222 to allow rooftop solar and other distributed energy resources to participate in the wholesale energy markets, advanced reform of the interconnection process in preparation for a regulatory filing in 2022, and became the first grid operator to publish real-time marginal emission data on a nodal basis as a tool to inform the energy use of our customers.</p>
                        <p className="text">I continue to believe in the power of our stakeholders and the stakeholder process to solve complex problems.</p>
                        <p className="text">As we move forward, our work will continue to be informed by our strategy and our foundational principles. Reliability will remain job number one as we work to facilitate state and federal decarbonization policies, plan for the grid of the future, and try to use our unique position as a provider of data, analysis and operational experience to become a center for innovation in our industry. We will also keep working with our stakeholders to evolve our competitive markets, so that the entire PJM region continues to benefit from the significant efficiencies these markets deliver.</p>
                        <p className="text">In pursuit of these goals, we will also continue to invest in our most valuable asset, our people, who continue to provide valuable expertise, experience and independent thought to work toward the success of our members, stakeholders and, ultimately, the 65 million people who depend on us to get it right every day.</p>
                        <p className="text">In 2022, PJM will celebrate its 95th anniversary of operation and the 25th anniversary of becoming an independent system operator and the beginning of competitive markets. There is much reason to celebrate this legacy. I look forward to listening, strengthening relationships and spending time in person with you this year.</p>
                        <p className="text">Warm regards,</p>
                        <p className="text text--bold">Manu Asthana<br></br>President & Chief Executive Officer</p>
                        
                    </div>
                </div>
            </main>
            <Footer 
                nextLink="/officers" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextTitle="Officers"
                nextButton="Read More"   
                nextRings={nextRings}
                prevLink="/welcome" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton="Read More"
                prevTitle="Welcome" 
                prevRings={prevRings} 
            />
        </Layout>
    )
}

export default BoardCeoLetters
